const FETCH_SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS';
const FETCH_SIMILAR_PRODUCTS_SUCCESS = 'FETCH_SIMILAR_PRODUCTS_SUCCESS';
const FETCH_SIMILAR_PRODUCTS_ERROR = 'FETCH_SIMILAR_PRODUCTS_ERROR';

const defaultState = {
    products: [],
    loading: false,
    error: null
};

export default function similarProductReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_SIMILAR_PRODUCTS:
            return {
                loading: true,
                error: null,
                products: []
            }
        case FETCH_SIMILAR_PRODUCTS_SUCCESS:
            return {
                loading: false,
                error: null,
                products: action.payload
            }
        case FETCH_SIMILAR_PRODUCTS_ERROR:
            return {
                loading: false,
                error: action.payload,
                products: []
            }
        default:
            return state
    }
}